var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.results.length > 0)?_c('CRMSearchResults',{attrs:{"items":_vm.results}}):(_vm.results.length === 0 && _vm.hasLoadedOnce)?_c('NoResultsMessage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }